import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
Vue.use(VueCompositionAPI);

import { ref } from '@vue/composition-api'
import axios from 'axios';
import qs from 'qs' //why qs? https://github.com/axios/axios#using-applicationx-www-form-urlencoded-format

const stateOptions = ref([])
const siteCountries = ref([])

export default function useGeo () {
    const getStateOptions = (name) => {
        stateOptions.value = siteCountries.value.find((country) => { return country.name == name}).states;
    }

    const getCountryId = (country) => {
        const params = qs.stringify({
            country: country
        })

        return axios.post('/actions/geo.cfc?method=getCountryId', params)
    }

    const getSiteCountries = () => {
        return new Promise(function(resolve){
            axios.get('/actions/geo.cfc?method=getSiteCountries').then(
                (resp) => {
                    siteCountries.value = resp.data
                    resolve(true);
                }
            )
        });
    }

    return {
        stateOptions,
        siteCountries,
        getStateOptions,
        getSiteCountries,
        getCountryId
    }
}
